import { defaultLang } from '@/utils/const';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: defaultLang,
  fallbackLng: defaultLang,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
